import { actionCreator, reducedStream, reducer } from '@ardoq/rxbeach';

export const alwaysSelectAllResults = actionCreator<boolean>(
  '[componentSearch] ALWAYS_SELECT_ALL_SETTING'
);

const alwaysSelectAllResultsReducer = (_: boolean, alwaysSelectAll: boolean) =>
  alwaysSelectAll;

export const alwaysSelectAll$ = reducedStream<boolean>(
  'alwaysSelectAll$',
  false,
  [reducer(alwaysSelectAllResults, alwaysSelectAllResultsReducer)]
);
